import axios, { AxiosRequestConfig } from 'axios';

import { AuthEmail, AuthToken, DataResponse } from '../types';

const URL = '/v2/admin-sso-test';

class AdminSSOTestService {
  static login(
    data: AuthEmail,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AuthToken>> {
    return axios.post(URL, data, config);
  }
}

export { AdminSSOTestService };
